export default "<div class=\"survey-container contentcontainer codecontainer\" id=\"surveyCreatorContainer\">\n    <div id=\"creatorElement\"></div>\n</div>";